import React from 'react';

const NotFound = () => {
  return (
    <div>
      <h1> Not Found</h1>
      <p className='lead'> The page you're looking doesn't exist... </p>
    </div>
  );
};
export default NotFound;



// WEBPACK FOOTER //
// ./src/components/pages/NotFound.js